(() => {
  const PRODUCT_INSTRUCTION = 'Elegí la modalidad de entrega al finalizar la compra.';
  const HOME_TITLES = ['compra segura', 'hasta tu puerta', 'retiro en grecia', 'whatsapp'];
  const HOME_DELIVERY_COPY = 'Recíbelo en 1–3 días hábiles.';
  const FOOTER_TRUST_COPY = 'Moda femenina seleccionada para vos, con atención cercana, compra segura y envíos a todo Costa Rica.';
  const INSTAGRAM_URL = 'https://www.instagram.com/gigi.store.cr';
  const WISHLIST_KEY = 'gigi_favoritos';
  const RECENT_DAYS = 15;
  const RECENT_LIMIT = 4;
  const CHOSEN_LIMIT = 4;
  const DAY_MS = 86400000;
  const REVIEW_DATA = [
    { name: 'María José Guido', text: 'Excelente atención y muy buena calidad. ¡Súper recomiendo!' },
    { name: 'Jocelyn Álvarez', text: 'Excelente atención. El pedido llega súper rápido y las cosas son de muy buena calidad ☺️' },
    { name: 'Ro Jes', text: 'Amé las prendas. Son de buena calidad, el envío fue rápido y la atención muy buena.' },
    { name: 'Shesllin Wright', text: 'Excelente servicio al cliente, buena calidad y entrega eficiente 🌿🌴' }
  ];

  const MERCH_STYLES = `
    .gigi-merch{width:100%;box-sizing:border-box;padding:38px 0;background:var(--color-background,#fff);color:var(--color-foreground,#171717)}
    .gigi-merch--chosen{background:#fbf7f8}
    .gigi-merch__inner{width:min(100% - 32px,1200px);margin:0 auto}
    .gigi-merch__header{display:flex;align-items:flex-end;justify-content:space-between;gap:20px;margin-bottom:18px}
    .gigi-merch__eyebrow{display:block;margin:0 0 5px;font-size:10px;line-height:1;font-weight:800;letter-spacing:.14em;color:#b91459}
    .gigi-merch__heading{margin:0;font-size:clamp(21px,2.2vw,29px);line-height:1.08;font-weight:650;letter-spacing:-.015em}
    .gigi-merch__description{max-width:55ch;margin:7px 0 0;font-size:12.5px;line-height:1.45;opacity:.68}
    .gigi-merch__link{flex:0 0 auto;color:inherit;font-size:12px;font-weight:700;text-decoration:none;border-bottom:1px solid currentColor;padding-bottom:2px}
    .gigi-merch__link:hover{opacity:.62}
    .gigi-merch__grid{display:grid;grid-template-columns:repeat(4,minmax(0,1fr));gap:22px 12px}
    .gigi-merch-card{min-width:0;position:relative}
    .gigi-merch-card__media{position:relative;aspect-ratio:4/5;overflow:hidden;border-radius:8px;background:#f5f3f2}
    .gigi-merch-card__media-link{display:block;width:100%;height:100%;color:inherit;text-decoration:none}
    .gigi-merch-card__image{display:block;width:100%;height:100%;object-fit:cover;transition:transform .3s ease}
    .gigi-merch-card:hover .gigi-merch-card__image{transform:scale(1.015)}
    .gigi-merch-card__badge{position:absolute;z-index:3;top:9px;left:9px;display:inline-flex;align-items:center;min-height:23px;padding:0 9px;border-radius:999px;background:#c92367;color:#fff;font-size:9px;line-height:1;font-weight:850;letter-spacing:.085em;box-shadow:0 2px 9px rgba(0,0,0,.08);pointer-events:none}
    .gigi-merch-card__heart{position:absolute;z-index:4;top:8px;right:8px;width:32px;height:32px;padding:0;border:0;border-radius:50%;display:grid;place-items:center;background:rgba(255,255,255,.92);color:#151515;font-size:20px;line-height:1;cursor:pointer;box-shadow:0 2px 10px rgba(0,0,0,.08)}
    .gigi-merch-card__heart.is-active{background:#fff1f6;color:#c92367}
    .gigi-merch-card__body{padding:8px 1px 0}
    .gigi-merch-card__title{display:-webkit-box;overflow:hidden;-webkit-box-orient:vertical;-webkit-line-clamp:2;min-height:2.65em;margin:0;color:inherit;font-size:12.5px;line-height:1.32;font-weight:500;text-decoration:none}
    .gigi-merch-card__title:hover{text-decoration:underline;text-underline-offset:2px}
    .gigi-merch-card__price{display:flex;align-items:baseline;gap:7px;flex-wrap:wrap;margin-top:5px;font-size:14px;line-height:1.2;font-weight:750}
    .gigi-merch-card__compare{font-size:11px;font-weight:450;opacity:.48;text-decoration:line-through}
    .gigi-merch-card__sizes{display:flex;gap:4px;flex-wrap:wrap;margin-top:7px}
    .gigi-merch-card__size{display:inline-flex;align-items:center;justify-content:center;min-width:24px;height:21px;padding:0 5px;border:1px solid rgba(17,17,17,.15);border-radius:4px;font-size:9px;line-height:1;font-weight:600}
    .gigi-merch-card__size-more{opacity:.62}
    .gigi-offers-source--hidden{display:none!important}
    @media(max-width:749px){
      .gigi-merch{padding:28px 0}
      .gigi-merch__inner{width:min(100% - 24px,1200px)}
      .gigi-merch__header{align-items:flex-start;gap:12px;margin-bottom:14px}
      .gigi-merch__heading{font-size:21px}
      .gigi-merch__description{margin-top:5px;font-size:11.5px;line-height:1.38}
      .gigi-merch__link{margin-top:2px;font-size:10.5px;white-space:nowrap}
      .gigi-merch__grid{grid-template-columns:repeat(2,minmax(0,1fr));gap:18px 8px}
      .gigi-merch-card__media{border-radius:7px}
      .gigi-merch-card__badge{top:7px;left:7px;min-height:21px;padding-inline:8px;font-size:8.5px}
      .gigi-merch-card__heart{top:6px;right:6px;width:30px;height:30px;font-size:19px}
      .gigi-merch-card__body{padding-top:7px}
      .gigi-merch-card__title{font-size:11.5px}
      .gigi-merch-card__price{margin-top:4px;font-size:13px}
      .gigi-merch-card__compare{font-size:10px}
      .gigi-merch-card__sizes{margin-top:6px;gap:3px}
      .gigi-merch-card__size{height:20px;min-width:22px;font-size:8.5px}
    }
    @media(prefers-reduced-motion:reduce){.gigi-merch-card__image{transition:none}.gigi-merch-card:hover .gigi-merch-card__image{transform:none}}
  `;

  function normalize(value = '') {
    return value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[·•]/g, ' ').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function escapeHtml(value = '') {
    return String(value).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#039;');
  }

  function homeSections() {
    return Array.from(document.querySelectorAll('.shopify-section'));
  }

  function cleanProductDeliveryCopy() {
    const details = document.querySelector('[data-testid="product-information-details"]');
    if (!details) return false;
    let found = false;
    details.querySelectorAll('strong').forEach((strong) => {
      const text = normalize(strong.textContent || '');
      if (text.includes('envios a todo costa rica') && text.includes('retiro gratuito en grecia')) {
        const paragraph = strong.closest('p');
        if (paragraph) { paragraph.textContent = PRODUCT_INSTRUCTION; found = true; }
      }
    });
    if (!found) {
      details.querySelectorAll('p').forEach((paragraph) => {
        const text = normalize(paragraph.textContent || '');
        if (text.includes('envios a todo costa rica') && text.includes('retiro gratuito en grecia') && text.includes('elegi la modalidad de entrega al finalizar la compra')) {
          paragraph.textContent = PRODUCT_INSTRUCTION;
          found = true;
        }
      });
    }
    return true;
  }

  function shieldIcon() {
    return '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 3 5.5 5.5v5.8c0 4.2 2.5 7.6 6.5 9.7 4-2.1 6.5-5.5 6.5-9.7V5.5L12 3Z"></path><path d="m9 12 2 2 4-4"></path></svg>';
  }
  function truckIcon() {
    return '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M3.5 6.5h10.5v10H3.5z"></path><path d="M14 10h3.5l3 3.5v3H14z"></path><path d="M17.5 10v3.5h3"></path><circle cx="7.5" cy="18" r="1.8"></circle><circle cx="17.5" cy="18" r="1.8"></circle></svg>';
  }
  function storeIcon() {
    return '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M4 9h16l-1.2-4H5.2L4 9Z"></path><path d="M5.5 9v10h13V9"></path><path d="M9 19v-5h6v5"></path><path d="M4 9c0 1.2 1 2 2.2 2S8.5 10.2 8.5 9c0 1.2 1 2 2.3 2S13 10.2 13 9c0 1.2 1 2 2.3 2s2.2-.8 2.2-2c0 1.2 1 2 2.5 2"></path></svg>';
  }
  function chatIcon() {
    return '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M20 11.5a8 8 0 0 1-11.7 7.1L4 20l1.4-4.1A8 8 0 1 1 20 11.5Z"></path><path d="M8.5 10.5h7M8.5 13.5h4.5"></path></svg>';
  }

  const HOME_ICON_MAP = { 'compra segura': shieldIcon, 'hasta tu puerta': truckIcon, 'retiro en grecia': storeIcon, whatsapp: chatIcon };
  const HOME_DESC_MAP = {
    'compra segura': ['tarjeta y sinpe movil.'],
    'hasta tu puerta': ['entregas a todo costa rica.', 'recibelo en 1–3 dias habiles.', 'recibelo en 1-3 dias habiles.'],
    'retiro en grecia': ['retiro gratuito en tienda.'],
    whatsapp: ['te acompanamos en tu compra.']
  };

  function findExactTextElement(root, expected) {
    return Array.from(root.querySelectorAll('h1,h2,h3,h4,h5,h6,p,span,div')).find((element) => normalize(element.textContent || '') === expected) || null;
  }
  function findTextElementByCandidates(root, candidates) {
    const normalized = candidates.map((candidate) => normalize(candidate));
    return Array.from(root.querySelectorAll('h1,h2,h3,h4,h5,h6,p,span,div')).find((element) => normalized.includes(normalize(element.textContent || ''))) || null;
  }
  function findHomeTrustSection() {
    return homeSections().filter((candidate) => {
      const text = normalize(candidate.textContent || '');
      return HOME_TITLES.every((title) => text.includes(title));
    }).sort((a, b) => (a.textContent || '').length - (b.textContent || '').length)[0] || null;
  }

  function decorateHomeTrust() {
    if (document.documentElement.dataset.gigiHomeTrustReady === 'true') return true;
    const section = findHomeTrustSection();
    if (!section) return false;
    section.classList.add('gigi-home-trust');
    const groups = Array.from(section.querySelectorAll('.group-block'));
    let decorated = 0;
    HOME_TITLES.forEach((title) => {
      const group = groups.find((candidate) => normalize(candidate.textContent || '').includes(title));
      if (!group) return;
      group.classList.add('gigi-home-trust__card');
      if (group.querySelector('a[href]') || group.getAttribute('href') || group.dataset.url || group.dataset.link) group.classList.add('gigi-home-trust__card--linked');
      const content = group.querySelector('.group-block-content') || group;
      content.classList.add('gigi-home-trust__content');
      if (!content.querySelector('.gigi-home-trust__icon')) {
        const icon = document.createElement('span');
        icon.className = 'gigi-home-trust__icon';
        icon.setAttribute('aria-hidden', 'true');
        icon.innerHTML = HOME_ICON_MAP[title]();
        content.insertBefore(icon, content.firstChild);
      }
      const titleElement = findExactTextElement(content, title);
      if (titleElement) titleElement.classList.add('gigi-home-trust__title');
      const descriptionElement = findTextElementByCandidates(content, HOME_DESC_MAP[title]);
      if (descriptionElement) {
        if (title === 'hasta tu puerta') descriptionElement.textContent = HOME_DELIVERY_COPY;
        descriptionElement.classList.add('gigi-home-trust__description');
      }
      decorated += 1;
    });
    if (decorated === HOME_TITLES.length) {
      document.documentElement.dataset.gigiHomeTrustReady = 'true';
      return true;
    }
    return false;
  }

  function findCollectionsSection() {
    const labels = ['ropa casual', 'ropa de playa', 'lenceria', 'pijamas', 'accesorios', 'tallas plus'];
    return homeSections().filter((section) => {
      const text = normalize(section.textContent || '');
      return text.includes('colecciones') && labels.filter((label) => text.includes(label)).length >= 5;
    }).sort((a, b) => (a.textContent || '').length - (b.textContent || '').length)[0] || null;
  }

  function fixCollectionLabels() {
    if (document.documentElement.dataset.gigiCollectionsReady === 'true') return true;
    const section = findCollectionsSection();
    if (!section) return false;
    const cards = Array.from(section.querySelectorAll('.collection-card'));
    if (cards.length < 4) return false;
    cards.forEach((card) => {
      card.classList.remove('collection-card--image-bg');
      card.classList.add('gigi-home-collection-card');
      card.querySelectorAll('.text-block--background').forEach((textBlock) => textBlock.classList.remove('text-block--background'));
    });
    document.documentElement.dataset.gigiCollectionsReady = 'true';
    return true;
  }

  function findTestimonialsHeadingSection() {
    return homeSections().filter((section) => {
      const text = normalize(section.textContent || '');
      return text.includes('lo que dicen nuestras clientas') && text.includes('experiencias reales');
    }).sort((a, b) => (a.textContent || '').length - (b.textContent || '').length)[0] || null;
  }
  function findTestimonialsCardsSection() {
    const names = ['maria jose guido', 'jocelyn alvarez', 'ro jes', 'shesllin wright'];
    return homeSections().filter((section) => {
      const text = normalize(section.textContent || '');
      return names.filter((name) => text.includes(name)).length >= 3;
    }).sort((a, b) => (a.textContent || '').length - (b.textContent || '').length)[0] || null;
  }

  function reviewItemsMarkup() {
    const intro = '<span class="gigi-review-ticker__item gigi-review-ticker__item--intro"><span class="gigi-review-ticker__stars" aria-hidden="true">✦ ✦</span><strong>Opiniones reales de clientas GIGI</strong></span>';
    const reviews = REVIEW_DATA.map((review) => '<span class="gigi-review-ticker__item"><span class="gigi-review-ticker__stars" aria-hidden="true">✦ ✦</span><span class="gigi-review-ticker__quote">“' + escapeHtml(review.text) + '”</span><strong class="gigi-review-ticker__name">— ' + escapeHtml(review.name) + '</strong><span class="gigi-review-ticker__heart" aria-hidden="true">♡</span></span>').join('');
    return intro + reviews;
  }

  function replaceTestimonialsWithTicker() {
    if (document.getElementById('gigi-review-ticker')) {
      document.documentElement.dataset.gigiTestimonialsReady = 'true';
      return true;
    }
    const headingSection = findTestimonialsHeadingSection();
    const cardsSection = findTestimonialsCardsSection();
    if (!headingSection || !cardsSection) return false;
    const ticker = document.createElement('section');
    ticker.id = 'gigi-review-ticker';
    ticker.className = 'gigi-review-ticker';
    ticker.setAttribute('aria-label', 'Opiniones reales de clientas GIGI');
    const items = reviewItemsMarkup();
    ticker.innerHTML = '<div class="gigi-review-ticker__viewport"><div class="gigi-review-ticker__track"><div class="gigi-review-ticker__set">' + items + '</div><div class="gigi-review-ticker__set" aria-hidden="true">' + items + '</div></div></div>';
    headingSection.insertAdjacentElement('beforebegin', ticker);
    headingSection.classList.add('gigi-testimonials-source--hidden');
    cardsSection.classList.add('gigi-testimonials-source--hidden');
    document.documentElement.dataset.gigiTestimonialsReady = 'true';
    return true;
  }

  function findInstagramSection() {
    return document.querySelector('[id*="178675026610e3bb7c"]') || homeSections().find((section) => Boolean(section.querySelector('[id*="instafeed"], [class*="instafeed"]'))) || null;
  }

  function decorateInstagramFeed() {
    if (document.getElementById('gigi-instagram-heading')) {
      document.documentElement.dataset.gigiInstagramReady = 'true';
      return true;
    }
    const instagramSection = findInstagramSection();
    if (!instagramSection) return false;
    const heading = document.createElement('div');
    heading.id = 'gigi-instagram-heading';
    heading.className = 'gigi-instagram-heading';
    heading.innerHTML = '<a class="gigi-instagram-heading__link" href="' + INSTAGRAM_URL + '" target="_blank" rel="noopener noreferrer"><span class="gigi-instagram-heading__heart" aria-hidden="true">♥</span><span>INSTAGRAM</span></a><p>Síguenos en <strong>@gigi.store.cr</strong> para ver novedades, looks y lanzamientos.</p>';
    instagramSection.insertAdjacentElement('beforebegin', heading);
    document.documentElement.dataset.gigiInstagramReady = 'true';
    return true;
  }

  function decorateFooterTrust() {
    if (document.documentElement.dataset.gigiFooterTrustReady === 'true') return true;
    const footer = document.querySelector('footer') || homeSections().find((section) => {
      const text = normalize(section.textContent || '');
      return text.includes('gigi costa rica') && text.includes('showroom en grecia');
    });
    if (!footer) return false;
    const heading = Array.from(footer.querySelectorAll('h1,h2,h3,h4,h5,h6,p')).find((element) => normalize(element.textContent || '') === 'gigi costa rica');
    if (!heading) return false;
    const group = heading.closest('.group-block') || heading.parentElement;
    if (!group) return false;
    const contactBlock = Array.from(group.querySelectorAll('.text-block, rte-formatter')).find((element) => normalize(element.textContent || '').includes('showroom en grecia'));
    if (!contactBlock) return false;
    if (!group.querySelector('.gigi-footer-trust')) {
      const trust = document.createElement('p');
      trust.className = 'gigi-footer-trust';
      trust.textContent = FOOTER_TRUST_COPY;
      contactBlock.insertAdjacentElement('beforebegin', trust);
    }
    document.documentElement.dataset.gigiFooterTrustReady = 'true';
    return true;
  }

  function findOffersSection() {
    return homeSections().find((section) => normalize(section.textContent || '').includes('ofertas destacadas')) || null;
  }

  function installMerchStyles() {
    if (document.getElementById('gigi-merch-styles')) return;
    const style = document.createElement('style');
    style.id = 'gigi-merch-styles';
    style.textContent = MERCH_STYLES;
    document.head.appendChild(style);
  }

  function shopPath(path = '') {
    const root = window.Shopify?.routes?.root || '/';
    return `${root.replace(/\/?$/, '/')}${String(path).replace(/^\//, '')}`;
  }

  async function fetchProducts(path) {
    const response = await fetch(shopPath(path), { credentials: 'same-origin', headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error(`GIGI merchandising fetch failed: ${response.status}`);
    const payload = await response.json();
    return Array.isArray(payload?.products) ? payload.products : [];
  }

  function productIsAvailable(product) {
    return Array.isArray(product?.variants) && product.variants.some((variant) => variant.available !== false);
  }

  function isNewProduct(product) {
    const created = Date.parse(product?.created_at || '');
    if (!Number.isFinite(created)) return false;
    const age = Date.now() - created;
    return age >= 0 && age <= RECENT_DAYS * DAY_MS;
  }

  function formatCRC(value) {
    const amount = Number(value);
    if (!Number.isFinite(amount)) return '';
    return `₡${new Intl.NumberFormat('es-CR', { maximumFractionDigits: 0 }).format(amount)}`;
  }

  function productImageSrc(product) {
    const featured = product?.featured_image;
    const first = Array.isArray(product?.images) ? product.images[0] : null;
    const source = typeof featured === 'string' ? featured : featured?.src || (typeof first === 'string' ? first : first?.src);
    if (!source) return '';
    try {
      const url = new URL(source, window.location.origin);
      url.searchParams.set('width', '700');
      return url.toString();
    } catch (_) {
      return source;
    }
  }

  function availableSizes(product) {
    const options = Array.isArray(product?.options) ? product.options : [];
    const sizeIndex = options.findIndex((option) => {
      const name = normalize(typeof option === 'string' ? option : option?.name || '');
      return name === 'talla' || name === 'size' || name.includes('talla');
    });
    if (sizeIndex < 0) return [];
    const key = `option${sizeIndex + 1}`;
    const values = [];
    (product.variants || []).forEach((variant) => {
      if (variant.available === false) return;
      const value = variant?.[key] || variant?.options?.[sizeIndex];
      if (!value || normalize(value) === 'default title' || values.includes(value)) return;
      values.push(value);
    });
    return values;
  }

  function readWishlist() {
    try {
      const data = JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]');
      return Array.isArray(data) ? data : [];
    } catch (_) {
      return [];
    }
  }

  function writeWishlist(items) {
    try { localStorage.setItem(WISHLIST_KEY, JSON.stringify(items)); } catch (_) { return; }
    document.querySelectorAll('.gigi-wishlist-count').forEach((node) => { node.textContent = String(items.length); });
    document.querySelectorAll('.gigi-wishlist-header').forEach((node) => node.classList.toggle('is-active', items.length > 0));
    window.dispatchEvent(new CustomEvent('gigi:wishlist:update', { detail: { items } }));
  }

  function syncMerchWishlistButtons(root = document) {
    const items = readWishlist();
    root.querySelectorAll('[data-gigi-merch-wishlist]').forEach((button) => {
      const active = items.some((item) => String(item?.handle || '') === String(button.dataset.handle || ''));
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
      button.setAttribute('aria-label', active ? 'Quitar de favoritos' : 'Agregar a favoritos');
      button.textContent = active ? '♥' : '♡';
    });
  }

  function bindMerchWishlist() {
    if (document.documentElement.dataset.gigiMerchWishlistBound === 'true') return;
    document.documentElement.dataset.gigiMerchWishlistBound = 'true';
    document.addEventListener('click', (event) => {
      const button = event.target instanceof Element ? event.target.closest('[data-gigi-merch-wishlist]') : null;
      if (!(button instanceof HTMLButtonElement)) return;
      event.preventDefault();
      event.stopPropagation();
      const handle = button.dataset.handle || '';
      if (!handle) return;
      const items = readWishlist();
      const index = items.findIndex((item) => String(item?.handle || '') === handle);
      if (index >= 0) items.splice(index, 1);
      else items.push({ id: button.dataset.productId || '', handle, title: button.dataset.title || '' });
      writeWishlist(items);
      syncMerchWishlistButtons(document);
    });
  }

  function productCardMarkup(product, forcedBadge = '') {
    const variant = (product.variants || []).find((item) => item.available !== false) || product.variants?.[0] || {};
    const price = Number(variant.price ?? 0);
    const compareAt = Number(variant.compare_at_price ?? 0);
    const image = productImageSrc(product);
    const href = shopPath(`products/${encodeURIComponent(product.handle || '')}`);
    const badge = forcedBadge || (isNewProduct(product) ? 'NUEVO' : '');
    const sizes = availableSizes(product);
    const visibleSizes = sizes.slice(0, 4);
    const remainingSizes = Math.max(0, sizes.length - visibleSizes.length);
    const sizeMarkup = visibleSizes.length
      ? `<div class="gigi-merch-card__sizes" aria-label="Tallas disponibles">${visibleSizes.map((size) => `<span class="gigi-merch-card__size">${escapeHtml(size)}</span>`).join('')}${remainingSizes ? `<span class="gigi-merch-card__size gigi-merch-card__size-more">+${remainingSizes}</span>` : ''}</div>`
      : '';
    const priceMarkup = `<div class="gigi-merch-card__price"><span>${formatCRC(price)}</span>${compareAt > price ? `<span class="gigi-merch-card__compare">${formatCRC(compareAt)}</span>` : ''}</div>`;
    return `
      <article class="gigi-merch-card">
        <div class="gigi-merch-card__media">
          <a class="gigi-merch-card__media-link" href="${escapeHtml(href)}" aria-label="${escapeHtml(product.title || '')}">
            ${image ? `<img class="gigi-merch-card__image" src="${escapeHtml(image)}" alt="${escapeHtml(product.title || '')}" loading="lazy" decoding="async">` : ''}
          </a>
          ${badge ? `<span class="gigi-merch-card__badge">${escapeHtml(badge)}</span>` : ''}
          <button type="button" class="gigi-merch-card__heart" data-gigi-merch-wishlist data-product-id="${escapeHtml(product.id || '')}" data-handle="${escapeHtml(product.handle || '')}" data-title="${escapeHtml(product.title || '')}" aria-label="Agregar a favoritos" aria-pressed="false">♡</button>
        </div>
        <div class="gigi-merch-card__body">
          <a class="gigi-merch-card__title" href="${escapeHtml(href)}">${escapeHtml(product.title || '')}</a>
          ${priceMarkup}
          ${sizeMarkup}
        </div>
      </article>`;
  }

  function buildMerchSection({ id, className = '', eyebrow, title, description, href, linkLabel, products, forcedBadge = '' }) {
    const section = document.createElement('section');
    section.id = id;
    section.className = `gigi-merch ${className}`.trim();
    section.innerHTML = `
      <div class="gigi-merch__inner">
        <header class="gigi-merch__header">
          <div>
            <span class="gigi-merch__eyebrow">${escapeHtml(eyebrow)}</span>
            <h2 class="gigi-merch__heading">${escapeHtml(title)}</h2>
            <p class="gigi-merch__description">${escapeHtml(description)}</p>
          </div>
          <a class="gigi-merch__link" href="${escapeHtml(href)}">${escapeHtml(linkLabel)}</a>
        </header>
        <div class="gigi-merch__grid">${products.map((product) => productCardMarkup(product, forcedBadge)).join('')}</div>
      </div>`;
    return section;
  }

  async function mountMerchandising() {
    const collectionsSection = findCollectionsSection();
    if (!collectionsSection) throw new Error('Collections section not ready');
    installMerchStyles();
    bindMerchWishlist();

    const [recentResult, chosenResult] = await Promise.allSettled([
      fetchProducts('collections/all/products.json?limit=24&sort_by=created-descending'),
      fetchProducts('collections/los-mas-elegidos/products.json?limit=8')
    ]);

    if (recentResult.status === 'fulfilled' && !document.getElementById('gigi-recent-arrivals')) {
      const recent = recentResult.value
        .filter((product) => productIsAvailable(product) && isNewProduct(product))
        .sort((a, b) => Date.parse(b.created_at || '') - Date.parse(a.created_at || ''))
        .slice(0, RECENT_LIMIT);
      if (recent.length) {
        const recentSection = buildMerchSection({
          id: 'gigi-recent-arrivals',
          className: 'gigi-merch--recent',
          eyebrow: 'NOVEDADES',
          title: 'Recién llegados',
          description: 'Lo último que llegó a GIGI, disponible para estrenar en días.',
          href: shopPath('collections/all?sort_by=created-descending'),
          linkLabel: 'Ver lo más nuevo',
          products: recent,
          forcedBadge: 'NUEVO'
        });
        collectionsSection.insertAdjacentElement('beforebegin', recentSection);
      }
    }

    if (chosenResult.status === 'fulfilled' && !document.getElementById('gigi-most-chosen')) {
      const chosen = chosenResult.value.filter(productIsAvailable).slice(0, CHOSEN_LIMIT);
      if (chosen.length) {
        const chosenSection = buildMerchSection({
          id: 'gigi-most-chosen',
          className: 'gigi-merch--chosen',
          eyebrow: 'FAVORITOS GIGI',
          title: 'Los más elegidos',
          description: 'Una selección basada en lo que nuestras clientas han elegido más recientemente.',
          href: shopPath('collections/los-mas-elegidos'),
          linkLabel: 'Ver todos',
          products: chosen
        });
        collectionsSection.insertAdjacentElement('afterend', chosenSection);
        findOffersSection()?.classList.add('gigi-offers-source--hidden');
      }
    }

    syncMerchWishlistButtons(document);
    document.documentElement.dataset.gigiMerchandisingState = 'ready';
  }

  function ensureMerchandising() {
    const state = document.documentElement.dataset.gigiMerchandisingState;
    if (state === 'ready' || state === 'loading') return true;
    if (!findCollectionsSection()) return false;
    document.documentElement.dataset.gigiMerchandisingState = 'loading';
    mountMerchandising().catch(() => {
      document.documentElement.dataset.gigiMerchandisingState = 'error';
    });
    return true;
  }

  function install() {
    const isProduct = document.querySelector('[data-testid="product-information-details"]');
    if (isProduct) return cleanProductDeliveryCopy();
    const isHome = window.location.pathname === '/' || document.body.classList.contains('template-index');
    if (!isHome) return true;
    const trustReady = decorateHomeTrust();
    const collectionsReady = fixCollectionLabels();
    const merchandisingReady = ensureMerchandising();
    const testimonialsReady = replaceTestimonialsWithTicker();
    const instagramReady = decorateInstagramFeed();
    const footerReady = decorateFooterTrust();
    return trustReady && collectionsReady && merchandisingReady && testimonialsReady && instagramReady && footerReady;
  }

  function resetHomeEnhancements() {
    delete document.documentElement.dataset.gigiHomeTrustReady;
    delete document.documentElement.dataset.gigiCollectionsReady;
    delete document.documentElement.dataset.gigiTestimonialsReady;
    delete document.documentElement.dataset.gigiInstagramReady;
    delete document.documentElement.dataset.gigiFooterTrustReady;
    delete document.documentElement.dataset.gigiMerchandisingState;
    document.getElementById('gigi-review-ticker')?.remove();
    document.getElementById('gigi-instagram-heading')?.remove();
    document.getElementById('gigi-recent-arrivals')?.remove();
    document.getElementById('gigi-most-chosen')?.remove();
    document.querySelectorAll('.gigi-offers-source--hidden').forEach((section) => section.classList.remove('gigi-offers-source--hidden'));
    document.querySelectorAll('.gigi-testimonials-source--hidden').forEach((section) => section.classList.remove('gigi-testimonials-source--hidden'));
  }

  function installWithRetry() {
    if (install()) return;
    let attempts = 0;
    const timer = window.setInterval(() => {
      attempts += 1;
      if (install() || attempts >= 30) window.clearInterval(timer);
    }, 180);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', installWithRetry, { once: true });
  else installWithRetry();
  window.addEventListener('pageshow', installWithRetry);
  document.addEventListener('shopify:section:load', () => {
    resetHomeEnhancements();
    window.setTimeout(installWithRetry, 0);
  });
})();
